import * as React from 'react';
import type { MarkPluginID } from '../plugins';
import type { RenderLeaf } from '../types';
import { TEXT_SOURCE_STYLING_PLUGIN_ID } from '../plugins/textSourceStyling/types';

export type GetRenderLeafOptions = Readonly<{
  /**
   * By passing true, helper automatically spreads any required attributes down to the component. If this is not used,
   * you must spread the attributes onto the component.
   *
   * @default true
   */
  spreadAttributes?: boolean;
}>;

export const getRenderLeaf = <
  PluginOptions extends Readonly<{
    pluginID: MarkPluginID;
    component: React.ComponentType<any>;
  }>,
>(
  { component: Component, pluginID }: PluginOptions,
  { spreadAttributes = true }: GetRenderLeafOptions = { spreadAttributes: true }
): RenderLeaf =>
  // @ts-expect-error [EN-7967] - TS2322 - Type '({ leaf, attributes, children, ...rest }: RenderLeafProps<BaseText>) => ReactNode' is not assignable to type 'RenderLeaf'.
  function GetRenderLeaf({ leaf, attributes, children, ...rest }): React.ReactNode {
    const bagToSpread = React.useMemo(() => {
      return spreadAttributes ? attributes : { attributes };
    }, [attributes]);

    if (
      typeof pluginID === 'string' &&
      // @ts-expect-error [EN-10263] - TS7053 - Element implicitly has an 'any' type because expression of type '"bold" | "italic" | "underline" | "highlighted" | "headingError"' can't be used to index type 'BaseText'.
      (pluginID === TEXT_SOURCE_STYLING_PLUGIN_ID || leaf[pluginID] != null) &&
      !!leaf.text
    ) {
      return (
        <Component
          data-editor-leaf={pluginID}
          {...bagToSpread}
          leaf={leaf}
          children={children}
          {...rest}
        />
      );
    }

    return children;
  };
